<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en-US" lang="en-US">

<body class="body">
  <div id="wrapper">
    <div class="modal fade modalCenter" id="login">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-sm">
          <div class="login-wrap">
            <div class="image">
              <img class="lazyload" data-src="../assets/images/section/login.jpg"
                src="../assets/images/section/login.jpg" alt="">
            </div>
            <div class="content">
              <div class="close-form">
                <a href="javascript:void(0)" class="btn-hide-popup" data-bs-dismiss="modal"><i
                    class="icon-close"></i></a>
              </div>
              <h4 class="title">
                Welcome to GoGo Money Maker
              </h4>
              <form class="form-login" id="form-login" [formGroup]="loginForm">
                <div class="cols mb-20">
                  <fieldset>
                    <label for="email">Email address</label>
                    <input id="email" type="email" required placeholder="Your email" name="email"
                      formControlName="emailAddress">
                  </fieldset>
                </div>
                <div class="cols mb-20 relative">
                  <fieldset>
                    <label for="password">Password</label>
                    <input class="password" id="pass" [type]="isPasswordVisible ? 'text' : 'password'" required
                      placeholder="Password" name="password" formControlName="password">
                    <span class="toggle-password second-time" (click)="togglePasswordVisibility()"
                      (keydown)="togglePasswordVisibility()" tabindex="0" role="button">
                      <i class="icon-view "></i>
                    </span>
                  </fieldset>
                </div>
                <div *ngIf="invalidCredentials">
                  <h6 style="color: #dc3545; font-weight: 500;  margin: 0;">The credentials you entered are incorrect.
                    Please try again.</h6>
                  <br>
                </div>
                <div *ngIf="inactiveAccount">
                  <h6 style="color: #dc3545; font-weight: 500;  margin: 0;">Your account is not actived yet. Check your
                    email account.</h6>
                  <br>
                </div>

                <div class="checkbox-item">
                  <a href="javascript:void(0)" class="type-main-color" (click)="openForgotPasswordModal()">Forgot my
                    password?</a>
                </div>
                <button type="button" class="btn-login tf-btn full-w"
                  [ngClass]="{ 'style-1': loginForm.valid, 'style-3': !loginForm.valid }" [disabled]="loginForm.invalid"
                  (click)="login()">
                  Log in
                </button>
              </form>
              <p class="bottom-form">
                Not registered yet?
                <a href="javascript:void(0);" class="type-main-color" (click)="openRegisterModal()">
                  Create a FREE Account
                </a>
                and start playing!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>

</html>